import apiClient from "services/apiClient";

async function editObservationActivity(data: any, id: any) {
  const url = `/admin/observations/${id}/comment`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editObservationActivity;
